export default __webpack_public_path__ + "static/media/icn-cobotics-status.e27350d5.svg";